import { App as AntApp, Button, Card, Form, InputNumber, Skeleton, Space, Typography } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings, useUpdateSettings, type AppSettings } from '../api/settings';
import { asApiError } from '@/shared/lib/api';

export function SettingsPage() {
  const { t } = useTranslation();
  const { message } = AntApp.useApp();
  const { data, isLoading } = useSettings();
  const update = useUpdateSettings();
  const [form] = Form.useForm<AppSettings>();

  useEffect(() => {
    if (data) form.setFieldsValue(data);
  }, [data, form]);

  async function onSave() {
    try {
      const v = await form.validateFields();
      await update.mutateAsync({ maxCumulativeLateDays: v.maxCumulativeLateDays });
      void message.success(t('settings.saved'));
    } catch (err) {
      if ((err as { errorFields?: unknown[] }).errorFields) return;
      void message.error(asApiError(err).message);
    }
  }

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Typography.Title level={3} style={{ margin: 0 }}>
        {t('settings.title')}
      </Typography.Title>

      {isLoading ? (
        <Skeleton active />
      ) : (
        <Card title={t('settings.paymentDiscipline')} style={{ maxWidth: 640 }}>
          <Form form={form} layout="vertical" requiredMark={false}>
            <Form.Item
              name="maxCumulativeLateDays"
              label={t('settings.maxCumulativeLateDays')}
              extra={t('settings.maxCumulativeLateDaysHint')}
              rules={[{ required: true, type: 'number', min: 0, max: 3650 }]}
            >
              <InputNumber min={0} max={3650} style={{ width: 220 }} addonAfter={t('settings.days')} />
            </Form.Item>
            <Button type="primary" loading={update.isPending} onClick={onSave}>
              {t('common.save')}
            </Button>
          </Form>
        </Card>
      )}
    </Space>
  );
}
